import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["state", "icon", "className"];
import React from 'react';
import { AnimatedIcon, IconCheckMarkCheck, IconCloseRoundStroked, IconInfoFilled, IconTimeOutline } from '@carnica/graphics';
import { cnBem } from '@carnica/utils';
import { statusViewPropState } from "../types";
import styles from "./styles.pcss";
var cnStatusViewIndicator = cnBem('status-view-indicator', styles);
export var StatusViewIndicator = function StatusViewIndicator(_ref) {
  var _ref$state = _ref.state,
    state = _ref$state === void 0 ? statusViewPropState[0] : _ref$state,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? IconInfoFilled : _ref$icon,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnStatusViewIndicator({
      state: state
    }, [className])
  }, otherProps, {
    "data-t-id": "StatusView-StatusViewIndicator"
  }), /*#__PURE__*/React.createElement(AnimatedIcon, {
    activeIndex: statusViewPropState.indexOf(state),
    color: state === 'info' || state === 'progress' ? 'black' : 'white',
    icons: [IconTimeOutline, IconCloseRoundStroked, icon, IconCheckMarkCheck],
    size: 60
  }));
};